import { Box, Container, Typography, useMediaQuery } from "@mui/material"
import React, { useContext } from "react";
import LogoComponents from "../globalComponents/logoComponents";
import AppBar from "./appBar";
import UserContext from "../../context";

const MenuBar = () => {

    const isMobile = useMediaQuery("(max-width:768px)");
    
    const styleBoxHeader: React.CSSProperties = { 
      backgroundColor: "#f3f3f3",
      position: "sticky",
      top: 0,
      zIndex: 2
  };
    const styleBoxStack: React.CSSProperties = { 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between", 
        boxSizing: "border-box", 
        position: "relative",
        height: "100%",
    };
    const styleTextEffect: React.CSSProperties = { 
      color: "#004387",
      textWrap: 'nowrap',
      fontSize: isMobile ? "0.8em" : "1.2em",
      flex: isMobile ? 1 : 0
    };
    const styleBoxTextEffect: React.CSSProperties = { 
      display: "flex",
      alignItems: "center",
      gap: "3em"
    };
    
    const ctx = useContext(UserContext);

    function maskCpf(cpf: string): string {
      return cpf.replace(/^(\d{3})\d{4}(\d{3})/, "$1****$2");
    }

    
    return (
        <Box component="header" style={styleBoxHeader} >
          <Container style={styleBoxStack}>
            <Box sx={styleBoxTextEffect}>
              <LogoComponents/>
              <Typography variant="h2" style={styleTextEffect}>
                A evolução do seu plano de saúde
              </Typography>
            </Box>
          {/* <DarkLightMode/> */}
          <Typography>
            {ctx?.user?.nome}  {ctx?.user?.sobrenome}
          </Typography>
          <Box></Box>
          </Container>
          <AppBar />
        </Box>
    );
}
export default MenuBar